import { render, staticRenderFns } from "./dishPreview.vue?vue&type=template&id=57a8d93c&scoped=true"
import script from "./dishPreview.vue?vue&type=script&lang=js"
export * from "./dishPreview.vue?vue&type=script&lang=js"
import style0 from "./dishPreview.vue?vue&type=style&index=0&id=57a8d93c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a8d93c",
  null
  
)

export default component.exports